import { createFileRoute } from '@tanstack/react-router';
import { creatorPortalVideoQuery } from '@/services/creator-portal-videos';
import { CreatorPortalVideo } from '@/features/creator-portal/videos/video-page';

/**
 * One video on the creator's portal: where it stands, the brief, handing in a draft (a file or a link), what the brand
 * asked for, every version, and the live link once approved. The loader starts the read (an id that isn't a number reads
 * nothing: the page says it can't find it) and never waits for it.
 */
export const Route = createFileRoute('/creator/$token/videos/$videoId')({
  loader: ({ context: { queryClient }, params }) => {
    if (/^\d{1,12}$/.test(params.videoId)) void queryClient.prefetchQuery(creatorPortalVideoQuery(params.token, Number(params.videoId)));
  },
  component: CreatorPortalVideoRoute,
});

function CreatorPortalVideoRoute() {
  const { token, videoId } = Route.useParams();
  return <CreatorPortalVideo token={token} videoId={videoId} />;
}
